import { AnalyticsBrowser } from '@segment/analytics-next';

import type { CurrentUser } from '@/types/user';
import { transformCamelToSpaceSeparated } from '@/utils/convertKeys';
const analytics = AnalyticsBrowser.load({ writeKey: import.meta.env.VITE_SEGMENT_WRITE_KEY });

const ANALYTICS_EVENTS = {
  appOpened: 'messages - opened',
  newMessageOpened: 'messages - new message opened',
  messageSent: 'messages - message sent',
  messageDiscarded: 'messages - message discarded',
  replyClicked: 'messages - reply clicked',
  replySent: 'messages - reply sent',
  replyDiscarded: 'messages - reply discarded',
  threadOpened: 'messages - thread opened',
  newTemplateClicked: 'messages - new template clicked',
  templateCreated: 'messages - template created',
  templateSaved: 'messages - template saved'
};

class SegmentAnalytics {
  static user: any = {};

  static async identifyUser(user: CurrentUser) {
    SegmentAnalytics.user = user;

    if(!analytics) return;

    await analytics.identify(user.id.toString(), {
      name: user.name,
      first_name: user.firstName,
      last_name: user.lastName,
      language: user.locale,
      influence_user_role: user.systemRole,
      modules: user.availableApps,
      ...SegmentAnalytics.baseEventProperties()
    }, SegmentAnalytics.eventOptions());
  }

  static async identifyGroup() {
    if(!analytics) return;

    await analytics.group(SegmentAnalytics.user.company.segmentGroupId, {
      global_customer_id: SegmentAnalytics.user.company.globalCustomerId,
      modules: SegmentAnalytics.user.company.availableApps,
      email: SegmentAnalytics.user.email,
    }, SegmentAnalytics.eventOptions());
  }

  static async trackEvent(eventKey: string, props = {}) {
    if (!analytics) return;

    const propsWithUserData = {
      ...transformCamelToSpaceSeparated(props),
      ...SegmentAnalytics.baseEventProperties()
    };

    await analytics.track(eventKey, propsWithUserData, SegmentAnalytics.eventOptions());
  }

  static baseEventProperties() {
    return {
      'organization id': SegmentAnalytics.user.falconOrgId,
      'organization name': SegmentAnalytics.user.companyKey,
      'falcon account id': SegmentAnalytics.user.falconAccountId,
      'paladin trial': SegmentAnalytics.user.demo,
      email: SegmentAnalytics.user.email,
      global_customer_id: SegmentAnalytics.user.globalCustomerId,
    };
  }

  static eventOptions() {
    return {
      integrations: {
        All: import.meta.env.MODE === 'staging' || import.meta.env.MODE === 'production',
        Mixpanel: import.meta.env.MODE === 'staging' || import.meta.env.MODE === 'production'
      }
    };
  }
}

export default SegmentAnalytics;
export { ANALYTICS_EVENTS };
